module.exports = __webpack_public_path__ + "static/Risto-Rautava-fdd7759feebc6463decb22fc215116f8.jpeg";